import { SkeletonAddOn } from 'components/cartAddOn';
import { SkeletonCartItemSide } from 'components/cartItemSide';
import { Skeleton } from 'components/common/skeleton';
import './CartForm.css';

const SkeletonCartForm = () => {
    return (
        <div className={`ab-room-info-page`}>
            <div className="ab-column">
                <div
                    className="ab-body-inner-header ab-search-filters-wrapper"
                    style={{ height: '93px' }}
                >
                    <Skeleton width={'100%'} height={93} />
                </div>

                <div className="ab-cart-wrapper">
                    <div className="ab-cart-right-side">
                        <div className="ab-cart-right-side-top">
                            <SkeletonCartItemSide />
                        </div>
                        <div className="ab-cart-right-side-top-bottom">
                            <Skeleton width={'100%'} height={42} />
                        </div>
                    </div>
                    <div className="ab-cart-left-side">
                        <div className="ab-cart-add-on-general-title">
                            <Skeleton width={'100%'} height={25} />
                        </div>
                        <div className="ab-cart-separate-line"></div>
                        <div className="ab-cart-add-on">
                            <SkeletonAddOn />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonCartForm;
